<template>
  <div
    class="grid-view__group-band"
    :data-band-group="value === null ? '' : value.id"
  >
    <!-- Setinha de recolher/expandir o grupo (estilo ClickUp). -->
    <a
      class="grid-view__group-band-collapse"
      @click.stop="$emit('toggle-collapse')"
    >
      <i
        :class="collapsed ? 'iconoir-nav-arrow-right' : 'iconoir-nav-arrow-down'"
      ></i>
    </a>
    <div class="grid-view__group-band-value">
      <component
        :is="groupByComponent"
        v-if="groupByComponent"
        :field="field"
        :value="value"
      />
    </div>
    <!-- Mostra a contagem também quando é 0 (grupo vazio), como o ClickUp. -->
    <div v-if="count >= 0" class="grid-view__group-band-count">
      {{ count }}
    </div>
    <a
      v-if="canAddRow && fieldIsWritable"
      class="grid-view__group-band-add"
      @click.stop="$emit('add-row-in-group', { groupBy, field, value })"
    >
      <i class="iconoir-plus"></i>
      {{ $t('gridView.addRowInGroup') }}
    </a>
  </div>
</template>

<script>
/**
 * Origem Flow: header de grupo estilo ClickUp — uma linha horizontal de
 * largura total renderizada no fluxo das linhas do grid, antes da primeira
 * linha de cada grupo, com a pill do valor, contagem e "+ Adicionar tarefa".
 */
export default {
  name: 'GridViewGroupBand',
  props: {
    groupBy: {
      type: Object,
      required: true,
    },
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: null,
      required: false,
      default: null,
    },
    count: {
      type: Number,
      required: false,
      default: -1,
    },
    canAddRow: {
      type: Boolean,
      required: false,
      default: false,
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['add-row-in-group', 'toggle-collapse'],
  computed: {
    fieldType() {
      return this.$registry.get('field', this.field.type)
    },
    groupByComponent() {
      return this.fieldType.getGroupByComponent(this.field)
    },
    fieldIsWritable() {
      return this.fieldType.canWriteFieldValues(this.field)
    },
  },
}
</script>
